"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
var react_1 = __importDefault(require("react"));
var texts_1 = require("../../ui/texts");
var permisos_1 = require("../../components/permisos");
var permisos_2 = require("../../hooks/permisos");
var recoil_1 = require("recoil");
var index_css_1 = __importDefault(require("./index.css"));
var mascotas_cercanas_1 = require("../../components/mascotas-cercanas");
function Home() {
    var permisos = (0, recoil_1.useRecoilValue)(permisos_2.permisosDeUbicacion);
    return (react_1.default.createElement("div", { className: index_css_1.default["home-container"] },
        react_1.default.createElement(texts_1.CustomTitle, null, "Mascotas perdidas cerca tuyo"),
        permisos ? react_1.default.createElement(mascotas_cercanas_1.MascotasCercanas, null) : react_1.default.createElement(permisos_1.Permisos, null)));
}
exports.Home = Home;
